import { render, staticRenderFns } from "./CaptchaSubmitButton.vue?vue&type=template&id=9027b670&scoped=true&"
import script from "./CaptchaSubmitButton.vue?vue&type=script&lang=ts&"
export * from "./CaptchaSubmitButton.vue?vue&type=script&lang=ts&"
import style0 from "./CaptchaSubmitButton.vue?vue&type=style&index=0&id=9027b670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9027b670",
  null
  
)

/* custom blocks */
import block0 from "./CaptchaSubmitButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VOtpInput})
